<template>
	<div>
		<!-- --- 약관 선택 --- -->
		<p v-if="where === 'reserve_day'" class="selectedRes my-5">
			예약확인 알림톡 발송을 위한 개인정보 활용에 동의해주세요. <span class="required-red-dot">*</span>
		</p>
		<p v-else class="selectedRes my-5">알림톡 발송을 위한 개인정보 활용에 동의해주세요. <span class="required-red-dot">*</span></p>
		<check-box :check="check1" @click="agreeAll"></check-box>
		<v-layout align-baseline>
			<check-box :check="check2" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="showTerm" @click="detail(1)">자세히 보기</span>
		</v-layout>
		<v-layout align-baseline>
			<check-box :check="check3" @click="checkAgree"></check-box><v-spacer></v-spacer>
			<span class="showTerm" @click="detail(2)">자세히 보기</span>
		</v-layout>
		<!-- <v-layout align-baseline>
			<check-box :check="check4" @click="disagree"></check-box><v-spacer></v-spacer>
			<span class="showTerm" @click="detail(3)">자세히 보기</span>
		</v-layout> -->
		<agree-dialog :setdialog="agreeDialog" />
	</div>
</template>

<script>
import checkBox from './checkBox.vue'
import agreeDialog from './dialog/agreeDialog.vue'

export default {
	components: { checkBox, agreeDialog },
	props: {
		urlInfo: String,
	},
	data() {
		return {
			agreeDialog: {
				dialog: false,
				title: '',
				content: '',
			},
		}
	},
	computed: {
		where() {
			return this.urlInfo.split('/')[1]
		},
		check1: {
			get() {
				return this.$store.state.check1
			},
			set(value) {
				this.$store.commit('check1', value)
			},
		},
		check2: {
			get() {
				return this.$store.state.check2
			},
			set(value) {
				this.$store.commit('check2', value)
			},
		},
		check3: {
			get() {
				return this.$store.state.check3
			},
			set(value) {
				this.$store.commit('check3', value)
			},
		},
		check4: {
			get() {
				return this.$store.state.check4
			},
			set(value) {
				this.$store.commit('check4', value)
			},
		},
	},
	methods: {
		detail(num) {
			this.terms(num)
		},
		terms(num) {
			const data = {
				stat: 1,
				type: num,
			}
			this.$store
				.dispatch('terms', data)
				.then(res => {
					this.agreeDialog.dialog = true
					this.agreeDialog.title = res.data.terms[0].title
					this.agreeDialog.content = res.data.terms[0].content
				})
				.catch(() => {})
		},
		agreeAll() {
			//전체동의
			if (this.check1.value) {
				this.check2.value = true
				this.check3.value = true
			} else {
				this.check2.value = false
				this.check3.value = false
			}
			this.check4.value = false
		},
		checkAgree() {
			//약관 동의
			if (this.check2.value && this.check3.value) {
				this.check1.value = true
			} else {
				this.check1.value = false
			}
			this.check4.value = false
		},
		disagree() {
			//동의 없이 시작
			if (this.check4.value) {
				this.check1.value = false
				this.check2.value = false
				this.check3.value = false
			}
		},
	},
}
</script>

<style lang="scss">
.selectedRes {
	font-size: 13px;
	font-weight: bold;
	margin-bottom: 0px !important;
	span {
		color: #006b8f;
	}
}
.showTerm {
	cursor: pointer;
	font-size: 12px;
	color: #a6a6a6;
	text-decoration: underline;
}
.required-red-dot {
	font-size: 24px;
	color: #ff5252 !important;
}
</style>
